export default "__VITE_ASSET__3g6ZiOYz__"